import { getRequest, postRequest } from 'api/apiUtils'
import { IS_PRODUCTION } from 'utils/helperConfig'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import {
    failureCancelBatchPaymentRequests,
    failureExecuteBatchPaymentRequests,
    failureGetBatchPaymentRequests,
    failureGetBatchPaymentStatuses,
    failureGetImportedBatchPayments,
    failureGetSingleImportedBatchPayment,
    failureImportBatchPaymentFile,
    successCancelBatchPaymentRequests,
    successExecuteBatchPaymentRequests,
    successGetBatchPaymentRequests,
    successGetBatchPaymentStatuses,
    successGetImportedBatchPayments,
    successGetSingleImportedBatchPayment,
    successImportBatchPaymentFile,
} from './batchPayments-actions'
import BatchPaymentsActionTypes from './batchPayments-types'

/*******************  Import Batch Payment File ********************* */
function* startImportBatchPaymentFile({ payload: { formData } }) {
    try {
        yield postRequest('/user/assets/bankAccounts/batch-withdrawals', formData)
        yield put(successImportBatchPaymentFile())
    } catch (err) {
        yield put(failureImportBatchPaymentFile({ errorMessage: err?.response?.data?.errors || [{ message: 'Importing batch payment file failed' }] }))
        if (!IS_PRODUCTION) {
            console.log('failureImportBatchPaymentFile')
        }
    }
}
export function* onStartImportBatchPaymentFile() {
    yield takeLatest(BatchPaymentsActionTypes.START_IMPORT_BATCH_PAYMENT_FILE, startImportBatchPaymentFile)
}

/*******************  Execute Batch Payment Requests ********************* */
function* startExecuteBatchPaymentRequests({ payload: { batchId, verificationCode, bankAccountWithdrawalRequestIds } }) {
    try {
        yield postRequest(`/user/assets/bankAccounts/${batchId}/batch-withdrawals/execute`, { verificationCode, bankAccountWithdrawalRequestIds })
        yield put(successExecuteBatchPaymentRequests())
    } catch (err) {
        yield put(failureExecuteBatchPaymentRequests({ errorMessage: err?.response?.data?.errors || [{ message: 'Executing batch payment requests failed' }] }))
        if (!IS_PRODUCTION) {
            console.log('failureExecuteBatchPaymentRequests')
        }
    }
}
export function* onStartExecuteBatchPaymentRequests() {
    yield takeLatest(BatchPaymentsActionTypes.START_EXECUTE_BATCH_PAYMENT_REQUESTS, startExecuteBatchPaymentRequests)
}

/*******************  Cancel Batch Payment Requests ********************* */
function* startCancelBatchPaymentRequests({ payload: { batchId, verificationCode, bankAccountWithdrawalRequestIds } }) {
    try {
        yield postRequest(`/user/assets/bankAccounts/${batchId}/batch-withdrawals/cancel`, { verificationCode, bankAccountWithdrawalRequestIds })
        yield put(successCancelBatchPaymentRequests())
    } catch (err) {
        yield put(failureCancelBatchPaymentRequests({ errorMessage: err?.response?.data?.errors || [{ message: 'Cancelling batch payment requests failed' }] }))
        if (!IS_PRODUCTION) {
            console.log('failureCancelBatchPaymentRequests')
        }
    }
}
export function* onStartCancelBatchPaymentRequests() {
    yield takeLatest(BatchPaymentsActionTypes.START_CANCEL_BATCH_PAYMENT_REQUESTS, startCancelBatchPaymentRequests)
}

/*******************  Fetch Batch Payment Statuses ********************* */
function* startGetBatchPaymentStatuses() {
    try {
        const { data } = yield getRequest('/user/assets/bankAccounts/batch-withdrawals/statuses')
        yield put(successGetBatchPaymentStatuses(data))
    } catch (err) {
        yield put(failureGetBatchPaymentStatuses({ errorMessage: err?.response?.data?.errors || [{ message: 'Getting batch payment statuses failed' }] }))
        if (!IS_PRODUCTION) {
            console.log('failureGetBatchPaymentStatuses')
        }
    }
}
export function* onStartGetBatchPaymentStatuses() {
    yield takeLatest(BatchPaymentsActionTypes.START_GET_BATCH_PAYMENT_STATUSES, startGetBatchPaymentStatuses)
}

/*******************  Fetch All Imported Batch Payments ********************* */
function* startGetImportedBatchPayments({ payload: { Skip, Limit } }) {
    try {
        const { data } = yield getRequest(`/user/assets/bankAccounts/batch-withdrawals?Skip=${Skip}&Limit=${Limit}`)
        yield put(successGetImportedBatchPayments(data))
    } catch (err) {
        yield put(failureGetImportedBatchPayments({ errorMessage: err?.response?.data?.errors || [{ message: 'Getting imported batch payments failed' }] }))
        if (!IS_PRODUCTION) {
            console.log('failureGetImportedBatchPayments')
        }
    }
}
export function* onStartGetImportedBatchPayments() {
    yield takeLatest(BatchPaymentsActionTypes.START_GET_IMPORTED_BATCH_PAYMENTS, startGetImportedBatchPayments)
}

/*******************  Fetch Single Imported Batch Payment ********************* */
function* startGetSingleImportedBatchPayment({ payload: { batchId } }) {
    try {
        const { data } = yield getRequest(`/user/assets/bankAccounts/batch-withdrawals/${batchId}`)
        yield put(successGetSingleImportedBatchPayment(data))
    } catch (err) {
        yield put(failureGetSingleImportedBatchPayment({ errorMessage: err?.response?.data?.errors || [{ message: 'Getting single imported batch payment failed' }] }))
        if (!IS_PRODUCTION) {
            console.log('failureGetSingleImportedBatchPayment')
        }
    }
}
export function* onStartGetSingleImportedBatchPayment() {
    yield takeLatest(BatchPaymentsActionTypes.START_GET_SINGLE_IMPORTED_BATCH_PAYMENT, startGetSingleImportedBatchPayment)
}

/*******************  Fetch Selected Batch Payments Requests ********************* */
function* startGetBatchPaymentRequests({ payload: { batchId } }) {
    try {
        const { data } = yield getRequest(`/user/assets/bankAccounts/${batchId}/batch-withdrawals/requests`)
        yield put(successGetBatchPaymentRequests(data))
    } catch (err) {
        yield put(failureGetBatchPaymentRequests({ errorMessage: err?.response?.data?.errors || [{ message: 'Getting batch payment requests failed' }] }))
        if (!IS_PRODUCTION) {
            console.log('failureGetBatchPaymentRequests')
        }
    }
}
export function* onStartGetBatchPaymentRequests() {
    yield takeLatest(BatchPaymentsActionTypes.START_GET_BATCH_PAYMENT_REQUESTS, startGetBatchPaymentRequests)
}

export function* batchPaymentsSagas() {
    yield all([
        call(onStartImportBatchPaymentFile),
        call(onStartExecuteBatchPaymentRequests),
        call(onStartCancelBatchPaymentRequests),
        call(onStartGetBatchPaymentStatuses),
        call(onStartGetImportedBatchPayments),
        call(onStartGetSingleImportedBatchPayment),
        call(onStartGetBatchPaymentRequests),
    ])
}
